import React, {useEffect, useState} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import {getEvents} from "api";
import Loading from "../Loading";
import moment from "moment";
import "./style.less";
import PageLayout from "../PageLayout";

const eventName = (event) => (
    event.name || event.nameRu || event.name_ru || event.nameEn || event.name_en || `Трансляция №${event.id}`
);
const eventPageUrl = ({eventPassword}) => (
    `/cp/event/${eventPassword}`
);

function EventListPage() {
    const [events, setEvents] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(async () => {
        setLoading(true);
        const events = await getEvents();
        setEvents(events);
        setLoading(false);
    }, []);

    if (isLoading) {
        return <Loading>Загрузка списка трансляций</Loading>
    }

    return (
        <div>
            {events.map((event) => (
                <a href={eventPageUrl(event)} key={event.id}>
                    <h4>{eventName(event)}</h4>
                    <p>Начало: {moment.unix(event.timeStart).format('YYYY-MM-DD HH:mm')}</p>
                    <p>Конец: {moment.unix(event.timeStop).format('YYYY-MM-DD HH:mm')}</p>
                </a>
            ))}
        </div>
    );
}

function EventCalendarPage() {
    async function fetchEvents(info, successCallback, failureCallback) {
        try {
            let events = await getEvents({
                timeStart: Math.round(info.start.getTime() / 1000),
                timeStop: Math.round(info.end.getTime() / 1000),
            });

            successCallback(events.map((event) => ({
                id: event.id,
                eventKey: event.eventKey,
                title: event.name || event.nameRu || event.name_ru || event.name_en || `Трансляция №${event.id}`,
                start: event.timeStart * 1000,
                end: event.timeStop * 1000,
                url: eventPageUrl(event),
            })));
        } catch (e) {
            failureCallback(e);
        }
    }

    return (
        <PageLayout>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView={'dayGridMonth'}
                locale={'ru'}
                dayMaxEvents={true}
                events={fetchEvents}
            />
        </PageLayout>
    );
}

// export default EventListPage;
export default EventCalendarPage;
